import { useState } from "react";
import { T } from "../../constants/theme";

const EXAMPLE_CHIPS = [
  "Organic Vegetable Seeds",
  "Raised Bed Starter Kit",
  "Heavy-Duty Garden Tools",
  "Peat-Free Compost",
  "Fast-Acting Fertiliser",
  "Fresh Weekly Produce Box",
];

export default function AISearchCard({ onSearch, loading }) {
  const [value, setValue] = useState("");

  const submit = (text) => {
    const query = (text ?? value).trim();
    if (query.length < 2) return;
    setValue(query);
    onSearch(query);
  };

  return (
    <div
      style={{
        maxWidth: 920,
        margin: "0 auto 40px",
        padding: "36px 32px",
        background: `linear-gradient(180deg, ${T.white} 0%, ${T.goldLight} 140%)`,
        border: `1px solid ${T.border}`,
       
        boxShadow: T.shadowMedium,
      }}
    >
      <div
        style={{
          fontSize: 11,
          letterSpacing: ".2em",
          textTransform: "uppercase",
          color: T.gold,
          fontWeight: 700,
          marginBottom: 8,
        }}
      >
        AI Growing Assistant
      </div>
      <p style={{ margin: "0 0 20px", color: T.inkSoft, fontSize: 15, lineHeight: 1.6 }}>
        Describe what you're growing and we'll recommend the perfect
        products.
      </p>
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
        <input
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && submit()}
          placeholder="Describe what you're growing..."
          style={{
            flex: "1 1 320px",
            padding: "16px 20px",
            fontSize: 15,
            border: `1px solid ${T.border}`,
            borderRadius: 12,
            background: T.white,
            outline: "none",
          }}
        />
        <button
          onClick={() => submit()}
          disabled={loading}
          style={{
            padding: "16px 28px",
            fontSize: 13,
            fontWeight: 700,
            letterSpacing: ".08em",
            textTransform: "uppercase",
            border: "none",
            borderRadius: 12,
            background: T.ink,
            color: T.white,
            cursor: loading ? "wait" : "pointer",
            opacity: loading ? 0.7 : 1,
          }}
        >
          {loading ? "Searching…" : "Find Products"}
        </button>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginTop: 18 }}>
        {EXAMPLE_CHIPS.map((chip) => (
          <button
            key={chip}
            onClick={() => submit(chip)}
            style={{
              padding: "8px 16px",
              fontSize: 12,
              fontWeight: 600,
              border: `1px solid ${T.border}`,
              borderRadius: 999,
              background: T.white,
              color: T.inkSoft,
              cursor: "pointer",
              transition: "all .2s ease",
            }}
          >
            {chip}
          </button>
        ))}
      </div>
    </div>
  );
}
